import { render } from "./ResellerLandingTop.vue?vue&type=template&id=1ca1e72e&scoped=true"
import script from "./ResellerLandingTop.vue?vue&type=script&lang=js"
export * from "./ResellerLandingTop.vue?vue&type=script&lang=js"

import "./ResellerLandingTop.vue?vue&type=style&index=0&id=1ca1e72e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ca1e72e"]])

export default __exports__